import { useMemo } from 'react';
import { useIsomorphicAxios } from '@unisporkal/federation';
import { httpClient } from '../../utils/httpClient';
import { DownloadService } from './download/downloadService';
import { LicenseService } from './license/licenseService';
import { CartsService } from './carts/cartsService';
import { LoadService } from './load/loadService';
import { UserService } from './users/userService';
import { SubscriptionService } from './subscription/subscriptionService';

/**
 * The api directory's service lookup. Composes every domain service over the
 * shared isomorphic HTTP client. Internal to the api directory — consumers
 * reach services through the domain hooks, not this hook directly
 * (Uni-ADR-014-api-directory). Each later story migrates a service out of the
 * legacy folder and types it; this hook stays JavaScript until that work lands.
 */
const useApi = () => {
  const axios = useIsomorphicAxios();
  return useMemo(() => {
    const client = httpClient(axios);
    const downloadService = new DownloadService(client);
    const licenseService = new LicenseService(client);
    const cartsService = new CartsService(client);
    const loadService = new LoadService(client);
    const userService = new UserService(client);
    const subscriptionService = new SubscriptionService(client);

    return {
      downloadService,
      licenseService,
      cartsService,
      loadService,
      userService,
      subscriptionService,
    };
  }, []);
};

export default useApi;
